// @flow
import React, { PureComponent } from 'react';

import { FacebookProvider, InstagramProvider, TwitterProvider, YoutubeProvider } from 'constants/socialConstants';
import FacebookCard from 'components/social/FacebookCard';
import InstagramCard from 'components/social/InstagramCard';
import TwitterCard from 'containers/social/TwitterCardContainer';
import YoutubeCard from 'components/social/YoutubeCard';
import type { SocialProvider, SocialContent } from 'types/SocialContent';
import type { FullUserType } from 'types/User';
import { handleTagEvent }from 'utils/tagManagerUtils';

export type StateProps = {
  userPref: FullUserType
}

type PropsCard = {
  content: SocialContent,
  transparent?: boolean,
  onClick: Function
};

type Props = StateProps & {
  content: SocialContent,
  transparent?: boolean
};

const CardArray: Array<[SocialProvider, (props: PropsCard) => React$Element<*>]> = [
  [FacebookProvider, FacebookCard],
  [TwitterProvider, TwitterCard],
  [InstagramProvider, InstagramCard],
  [YoutubeProvider, YoutubeCard]
];

class SocialCard extends PureComponent<Props> {
  transformHashtagsToStrongHastags = (text: string) => {
    if (text === '') {
      return text;
    }
    return text
      .split(' ')
      .reduce(
        (accumulator, currentValue) =>
          currentValue.includes('#')
            ? `${accumulator} <strong>${currentValue}</strong>`
            : `${accumulator} ${currentValue}`,
        ''
      );
  };

  render() {
    const { userPref } = this.props;
    const card = CardArray.find(c => c[0] === this.props.content.type);

    const styledDescription = this.transformHashtagsToStrongHastags(this.props.content.description);
    const content = { ...this.props.content, description: styledDescription };
    const props = { ...this.props, content };

    if (card) {
      const Component = card[1];
      return <Component
              onClick={handleTagEvent(
                'social wall', 
                'interaction publication',
                this.props.content.type,
                userPref               
              )}
              {...props} />;
    }

    return null;
  }
}

export default SocialCard;
